import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { MainComponent } from './main/main.component';
import { ProductComponent } from './product/product.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { NosotrosComponent } from './nosotros/nosotros.component';
import { ContactoComponent } from './contacto/contacto.component';

import { MensajesContactoService } from './services/mensajes-contacto.service';

import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { NgxSpinnerModule } from 'ngx-spinner';

const appRoutes: Routes = [
  { path: '', component: MainComponent},
  { path: 'product/:id', component: ProductComponent},
  { path: 'checkout', component: CheckoutComponent},
  { path: 'nosotros', component: NosotrosComponent},
  { path: 'contacto/:seccion', component: ContactoComponent},
  { path: '**', component: MainComponent}
];

const FIREBASE_CREDENTIALS = {
  apiKey: "AIzaSyDsqEbpZZlY8Ux6qNvUkpL-Lt4ANjXIo3M",
  authDomain: "editorial-28377.firebaseapp.com",
  databaseURL: "https://editorial-28377.firebaseio.com",
  projectId: "editorial-28377",
  storageBucket: "editorial-28377.appspot.com",
  messagingSenderId: "1042921432699"
};

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    NavbarComponent,
    MainComponent,
    ProductComponent,
    CheckoutComponent,
    NosotrosComponent,
    ContactoComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(
      appRoutes
    ),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    GooglePlaceModule,
    AngularFireModule.initializeApp(FIREBASE_CREDENTIALS),
    AngularFirestoreModule.enablePersistence(),
    NgxSpinnerModule
  ],
  providers: [
    MensajesContactoService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/lgh/Documents/apps/editorial/src/app/app.module.ts